import React from "react";
import { usePFDataContext } from "../context/PfContext";

const RemoveFromCartIcon = ({ productId }) => {
    const { pfData, updatePfData } = usePFDataContext();

    const removeFromCart = () => {
        // Filter out the product with the given productId from the cart
        const updatedCart = {
            ...pfData.cart,
            products: pfData.cart.products.filter((item) => item.id !== productId),
        };

        // Update the cart in the context
        updatePfData("cart", updatedCart);
        console.log("Product removed from cart:", productId);
    };

    return (
        <div className="item__remove-from-cart"  onClick={removeFromCart}>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="24px" height="24px" role="img" aria-label="Remove from cart">
                <path
                    d="M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z"
                    fill="#444"
                />
            </svg>
        </div>
    );
};

export default RemoveFromCartIcon;
